import { render, staticRenderFns } from "./SelectedGame.vue?vue&type=template&id=5610ef4d&scoped=true"
import script from "./SelectedGame.vue?vue&type=script&lang=js"
export * from "./SelectedGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5610ef4d",
  null
  
)

export default component.exports